// extracted by mini-css-extract-plugin
export default {"header":"admins_header__3oI1j","header__text":"admins_header__text__TCFB7","header__addButtonText":"admins_header__addButtonText__WWQSx"};